<template>
  <multiselect v-model="nacionalidade"
               v-on-leaving-select
               :label="campo"
               track-by="codigo"
               placeholder="Digite para buscar"
               select-label=""
               open-direction="bottom"
               :options="selectsOptions.nacionalidades"
               :searchable="true"
               :loading="selectNacionalidadesIsLoading"
               :internal-search="false"
               :clear-on-select="true"
               :close-on-select="true"
               :options-limit="300"
               :limit="3"
               :limit-text="limitText"
               :max-height="300"
               :show-no-results="false"
               :show-labels="false"
               @search-change="searchNacionalidade"
               @select="(nacionalidade) => changeNacionalidade(nacionalidade)">
    <template slot="option"
              slot-scope="props">
      <div class="option__desc">
        <span class="option__title"><b>{{ propSexo == 'F' ? props.option.nome_feminino : props.option.nome_masculino }}</b> ({{ props.option.nome }})</span>
      </div>
    </template>
  </multiselect>
</template>

<script>
  import NacionalidadesService from "@/services/NacionalidadesService"

  export default {
    name: 'Nacionalidades',
    props: {
      propNacionalidade: { type: Object, default: () => ({
        codigo: 76,
        nome: "Brasil",
        nome_feminino: "brasileira",
        nome_masculino: "brasileiro"
      })},
      propSexo: { type: String, default: "M" },
      value: { type: Number, default: null }
    },
    data () {
      return {
        nacionalidade: {
          codigo: 76,
          nome: "Brasil",
          nome_feminino: "brasileira",
          nome_masculino: "brasileiro"
        },
        selectNacionalidadesIsLoading: false,
        selectsOptions: {
          nacionalidades: [
            {
              codigo: null,
              nome: 'Não informada',
              nome_feminino: 'Não informada',
              nome_masculino: 'Não informada'
            },
            {
              codigo: 76,
              nome: "Brasil",
              nome_feminino: "brasileira",
              nome_masculino: "brasileiro"
            }
          ]
        },
        campo: 'nome_masculino'
      }
    },
    watch: {
      propNacionalidade () {
        this.init()
      },
      propSexo () {
        this.campo = this.propSexo == 'F' ? 'nome_feminino' : 'nome_masculino'
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.campo = this.propSexo == 'F' ? 'nome_feminino' : 'nome_masculino'

        const nenhuma = {
          codigo: null,
          nome: 'Não informada',
          nome_feminino: 'Não informada',
          nome_masculino: 'Não informada'
        }

        if (!!this.value) {
          this.nacionalidade = this.propNacionalidade
          this.nacionalidade.codigo = this.propNacionalidade && this.propNacionalidade.codigo
        } else {
          this.nacionalidade = nenhuma
          this.nacionalidade.codigo = nenhuma.codigo
        }
      },
      limitText (count) { return `e ${count} outros` },
      searchNacionalidade (busca) {
        if (!busca) { return }
        this.selectNacionalidadesIsLoading = true

        const response = NacionalidadesService.searchNacionalidadeByName(busca, this.campo)

        const nenhuma = {
          codigo: null,
          nome: 'Não informada',
          nome_feminino: 'Não informada',
          nome_masculino: 'Não informada'
        }

        this.selectsOptions.nacionalidades = [nenhuma, ...response]
        this.selectNacionalidadesIsLoading = false
      },
      changeNacionalidade (nacionalidade) {
        if (nacionalidade) {
          this.$emit('input', nacionalidade.codigo)
          this.$emit('updated', nacionalidade)
        }
      },
    }
  }
</script>
